<div class="row">
  <form #createSalesOrderForm="ngForm">
    <nb-card accent="info">
      <nb-card-header class="text-center clear-fix">
        <button
          nbButton
          outline
          size="tiny"
          status="info"
          class="float-end"
          (click)="cancel(createSalesOrderForm.form.dirty)"
        >
          x
        </button>
        <br />
        <div *ngIf="salesOrderBatchUUID">Edit Batch</div>
        <div *ngIf="!salesOrderBatchUUID">New Batch</div>
      </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="typeInput" class="label">Type</label>
              <ng-select
                [(ngModel)]="salesOrderBatch.type"
                [items]="tapeTypeOptions"
                appendTo="body"
                placeholder="Select Type"
                bindLabel="tapeModel"
                bindValue="tapeModel"
                [disabled]="hasTapes"
                name="typeInput"
                required
              >
              </ng-select>
            </div>
            <div class="mb-3">
              <label for="manufacturerInput" class="label">Manufacturer</label>
              <ng-select
                [(ngModel)]="salesOrderBatch.manufacturer"
                [items]="tapeManufacturerOptions"
                appendTo="body"
                placeholder="Select Manufacturer"
                bindLabel="manufacturerName"
                bindValue="manufacturerName"
                [disabled]="hasTapes"
                appendTo="body"
                [clearable]="false"
                name="manufacturerInput"
                required
              >
              </ng-select>
            </div>
            <div class="mb-3">
              <label for="statusConditionInput" class="label">Condition</label>
              <ng-select
                [(ngModel)]="salesOrderBatch.statusCondition"
                [items]="conditionOptions"
                placeholder="Select Condition..."
                notFoundText="Condition options unavailable"
                bindValue="value"
                bindLabel="label"
                [disabled]="hasTapes"
                appendTo="body"
                [clearable]="false"
                name="statusCondition"
                required
              >
              </ng-select>
            </div>
            <div class="mb-3">
              <label for="quantityInput" class="label">Quantity</label>
              <input
                type="number"
                min="1"
                nbInput
                fullWidth
                required
                [status]="displayFieldCss(createSalesOrderForm, quantityInput)"
                maxlength="50"
                id="quantityInput"
                name="quantityInput"
                [(ngModel)]="salesOrderBatch.quantity"
                #quantityInput="ngModel"
                fieldSize="small"
              />
              <app-form-field-error
                [displayError]="quantityInput.touched && quantityInput.invalid"
                [displaySuccess]="quantityInput.valid"
                errorMsg="Quantity is required"
              ></app-form-field-error>
            </div>
            <div class="mb-3">
              <label for="pricePerTapeInput" class="label"
                >Price per Tape</label
              >
              <nb-form-field fieldSize="small">
                <span nbPrefix>{{currencySymbol}}</span>
                <input
                  type="number"
                  min="0"
                  nbInput
                  required
                  [status]="displayFieldCss(createSalesOrderForm, pricePerTapeInput)"
                  maxlength="50"
                  id="pricePerTapeInput"
                  name="pricePerTapeInput"
                  [(ngModel)]="salesOrderBatch.pricePerTape"
                  #pricePerTapeInput="ngModel"
                  [disabled]="hasTapes"
                  (blur)="formatPricePerTape()"
                  step="0.01"
                /> </nb-form-field
              ><app-form-field-error
                [displayError]="pricePerTapeInput.touched && pricePerTapeInput.invalid"
                [displaySuccess]="pricePerTapeInput.valid"
                errorMsg="Price per Tape is required"
              ></app-form-field-error>
            </div>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer class="clear-fix">
        <div class="alert alert-danger" *ngIf="formError.error">
          Creating Sales Order failed...
        </div>
        <div class="alert alert-success" *ngIf="formError.success">
          Saving Sales Order was successful!
        </div>
        <button
          *ngIf="salesOrderUUID"
          nbButton
          outline
          status="success"
          [disabled]="createSalesOrderForm.invalid || formError.submitting || !createSalesOrderForm.dirty"
          type="submit"
          value="submit"
          (click)="submit()"
          class="float-end"
        >
          Save
        </button>
        <button
          *ngIf="!salesOrderUUID"
          nbButton
          outline
          status="success"
          [disabled]="createSalesOrderForm.invalid || formError.submitting || !createSalesOrderForm.dirty"
          type="submit"
          value="submit"
          (click)="submit()"
          class="float-end"
        >
          Add
        </button>
        <button
          nbButton
          outline
          status="danger"
          *ngIf="createSalesOrderForm.dirty || createSalesOrderForm.dirty && !formError.submitting"
          class="float-start"
          (click)="cancel(createSalesOrderForm.form.dirty)"
        >
          Cancel
        </button>
      </nb-card-footer>
    </nb-card>
  </form>
</div>
